
// Stateless components

export function StaffView(props) {


    //
    // Render
    //

    return (
        <div className="simulation-panel__dialogue__toggle-view">
            <label className="simulation-panel__dialogue__toggle-view__toggle" >
                <input type="checkbox" className="simulation-panel__dialogue__toggle-view__toggle__checkbox" onClick={props.handleToggle} defaultChecked={props.active} />
                <span className="simulation-panel__dialogue__toggle-view__toggle__slider"></span>
                <span className="simulation-panel__dialogue__toggle-view__toggle__text--initial">Student View</span>
                <span className="simulation-panel__dialogue__toggle-view__toggle__text">Staff View</span>
            </label>
        </div>
    );
};
